export default function Stylesheet() {
  return (
    <section className="page flex-centered">
      <h1>{'Hello World'}</h1>
      <h2>{'Hello World'}</h2>
      <h3>{'Hello World'}</h3>
      <h4>{'Hello World'}</h4>
      <h5>{'Hello World'}</h5>
      <h6>{'Hello World'}</h6>
      <p>{'More information coming Spring 2026'}</p>
    </section>
  );
}
